import type React from 'react'
import { Box, OutlinedInput } from '@mui/material'
import { ErrorText, FormLabel } from 'components'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'
import { color } from 'config/color'


interface TextInputProps {
    fieldName: string
    fieldLabel: string
    fieldType: string
    control: Control<any>
    errors: FieldErrors<any>
    placeholder?: string
}

export const TextInput: React.FC<TextInputProps> = (props: TextInputProps) => {
    return <Controller
        name={props.fieldName}
        control={props.control}
        render={({ field: { onChange, value, name } }): JSX.Element => (
            <Box mb={2}>
                <FormLabel>{props.fieldLabel.toUpperCase()}</FormLabel>
                <OutlinedInput
                    name={name}
                    placeholder={props.placeholder ?? `Enter your ${props.fieldLabel.toLowerCase()}`}
                    onChange={onChange}
                    value={value}
                    type={props.fieldType}
                    fullWidth
                    inputProps={{
                        style: { color: color.grey[700] }
                    }}
                />
                {(props.errors[props.fieldName] != null) && (
                    <ErrorText>{String(props.errors[props.fieldName]?.message)}</ErrorText>
                )}
            </Box>
        )}
    />
}
